import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { slide as Menu } from 'react-burger-menu';
import { decorator as reduxBurgerMenu } from 'redux-burger-menu';

import './index.css';
import { InitialsBubble, MenuGreeting, IconList } from 'common/components';
import { TCModal } from 'containers';
import { cog as CogIcon } from 'common/svg/icons';

const BurgerMenu = reduxBurgerMenu(Menu);

/**
 *
 *
 * @class SliderMenu
 * @extends {PureComponent}
 * @deprecated Not in use currently and possibly broken. Consider removing it if we don't need it.
 */
class SliderMenu extends PureComponent {
  state = {
    active: false,
  };

  handleTCClick = () => {
    this.setState({ active: true });
  };

  render() {
    const { userInfo, onLogout } = this.props;
    return (
      <BurgerMenu
        bodyClassName="mobile-menu--is-open"
        className="slider-menu"
        width="78%"
      >
        <header className="slider-menu__header is-flex">
          <InitialsBubble
            userInfo={userInfo}
            className="slider-menu__initials"
          />
          <MenuGreeting name={userInfo.firstName} email={userInfo.email} />
          <CogIcon className="slider-menu__cog" width="19px" height="19px" />
        </header>
        <nav
          className="account-links is-flex"
          role="navigation"
          aria-label="account settings"
        >
          <ul className="account-links__list is-flex">
            <IconList
              list={[
                { label: 'Web Support', icon: 'question', action: () => {} },
                {
                  label: 'Terms & Conditions',
                  icon: 'document',
                  action: this.handleTCClick,
                },
              ]}
              theme={['large', 'primary']}
            />
            <li
              className="account-links__logout margin--top-auto text--fade"
              onClick={onLogout}
            >
              Logout
            </li>
          </ul>
        </nav>

        <TCModal active={this.state.active} />
      </BurgerMenu>
    );
  }
}

SliderMenu.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default SliderMenu;



// WEBPACK FOOTER //
// ./src/common/components/SliderMenu/index.js